import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Vector from "../../../assets/images/empty-checkout.svg";
import LayoutContext from "../../../contexts/LayoutContext";
import UserContext from "../../../contexts/UserContext";
import ConfirmPurchaseLayout from "../../sections/ConfirmPurchaseLayout";
import * as Formatter from "../../../utils/Formatter";
import PaymentPopup from "../dialogs/PaymentPopup";
import axios from "axios";
import { CREATE_ORDER } from "../../../api/Endpoints";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import logGA4Event from "../../../utils/firebase/analytics";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../contexts/AppContext";
import CheckoutItemCard from "../../sections/CheckoutItemCard";
import CheckoutCardHeader from "./CheckoutCardHeader";
import InfoNote from "./InfoNote";
import { handlePaymentMethods, useSocialPayment } from "../../../utils/payments";
import { paymentMethods } from "../../../utils/helperFunctions";
import { createStripePayment, handlePostPayment } from "../../../utils/payments/common";

/* #region SCOPED CSS */
const StyledCheckoutPanel = styled.div`
    &.multi-bag-desktop-panel,
    &.multi-bag-desktop-panel * {
        box-sizing: border-box;
    }
    &.multi-bag-desktop-panel {
        height: 100%;
        position: relative;
        overflow: hidden;
        width: 100%;

        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
    }
    .panel-headers {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        flex-shrink: 0;
    }
    .frame-313366 {
        background: var(--wrap-wrap-brand, rgba(247, 102, 95, 0.1));
        border-radius: 500px;
        padding: 4px 14px 4px 14px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .quick-checkout {
        color: var(--text-text-brand, #f7665f);
        text-align: center;
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
        position: relative;
    }
    .frame-313365 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        width: 159px;
        position: relative;
    }
    .btn-xs-secondary {
        background: var(--buttons-button-secondary, #212121);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .separator {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: auto;
        margin-top: 16px;
        margin-bottom: 16px;

        border-style: solid;
        border-color: var(--border-border-tertiary, #373737);
        border-width: 0.5px 0 0 0;
        flex-shrink: 0;
    }
    .empty-checkout {
        padding: 18px 32px 18px 32px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 100vh;
        position: relative;
        left: 0px;
        top: 48px;
        overflow: hidden;
    }
    .frame-313697 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313691 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        top: -72px;
    }
    .vector {
        flex-shrink: 0;
        width: 63.75px;
        height: 60px;
        position: relative;
        overflow: visible;
    }
    .your-checkout-is-empty {
        color: #8c8c8c;
        text-align: center;
        font-family: var(--caption-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--caption-font-size, 12px);
        line-height: var(--caption-line-height, 20px);
        font-weight: var(--caption-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loader-bg-mobile {
        position: absolute;
        z-index: 999;
        height: 100%;
        width: 100%;
        backdrop-filter: blur(7px);
        border-left: 1px solid rgba(166, 166, 166, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 16px;
        /* background-color: rgba(0, 0, 0, 0.4); */
    }
    &.blur-bg {
        filter: blur(5px);
    }
`;

const CheckoutItemsStyles = styled.div`
    &.frame-29739,
    &.frame-29739 * {
        box-sizing: border-box;
    }
    &.frame-29739 {
        // display: flex;
        // gap: 16px;
        // align-items: flex-start;
        // justify-content: flex-start;
        // position: relative;
        // flex-shrink: 1;
        // overflow: hidden;
        //height: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
    }
`;

/* #endregion */

export default function CheckoutPanel() {
    /* #region VARS */
    const {
        setShowRightCheckoutPanel,
        showPaymentPopup,
        paymentPopupData,
        shippingAddressPopupData,
        setPlaceOrderLoading,
        placeOrderLoading,
        setShowPaymentPopup,
        setShowThankyouPopup,
        setStripeCardData,
        setOrderID,
        courierInstructionsData,
        setShowBOImagePageID,
        setShowRightUserLocationPanel,
        isMobile,
        setCardPlaceOrderLoading,
        placeOrderLoadingAnimation,
        setPlaceOrderLoadingAnimation,
        setQuickBuyPopup,
        setShowCheckoutSuccessBlink,
        setIsCardPayment,
        selectedPaymentType,
        setSelectedPaymentType
    } = React.useContext(LayoutContext);
    const {
        checkoutCartData,
        checkoutPaymentData,
        BOTagAccountID,
        shippingRecipient,
        setCheckoutPaymentData,
        userData,
        setUserData,
        setCheckoutCartData,
        setThankYouAmount
    } = React.useContext(UserContext);
    const { selectedBOImageData, shopperBagItem } = React.useContext(AppContext);
    const navigate = useNavigate();
    const elements = useElements();
    const stripe = useStripe();
    const [singleItemId, setSingleItemId] = useState("");
    const [selectedOption, setSelectedOption] = useState("All");

    const handleCreateOrderPostPayment = async ({
        res,
        savedPaymentMethodType,
        data,
        cardElement,
        selectedPaymentType: selectedPayment
    }) => {
        const { cardInfo, createOrderArgs, isSuccessFull } = await handlePostPayment({
            cardElement,
            selectedPaymentType: selectedPayment,
            BOTagAccountID,
            data,
            res,
            savedPaymentMethodType
        });

        cardInfo && setCheckoutPaymentData(cardInfo);
        if (createOrderArgs.length > 0 && isSuccessFull) {
            await createNewOrder(...createOrderArgs);
        }
    };

    const onError = () => {
        setPlaceOrderLoadingAnimation(false);
        setPlaceOrderLoading(false);
        setCardPlaceOrderLoading(false);
    };

    const { paymentRequest } = useSocialPayment({
        onSuccess: handleCreateOrderPostPayment,
        cartData: checkoutCartData,
        onError
    });
    const [successOrder, setSuccessOrder] = useState(false);
    /* #endregion */

    /* #region METHODS */
    const resetStates = ({ newOrder, orderID }) => {
        setSelectedPaymentType(paymentMethods.CARD);
        setPlaceOrderLoadingAnimation(false);
        setStripeCardData({
            isCardNumber: false,
            isCardExpData: false,
            isCardCvv: false,
            isComplete: false
        });
        setPlaceOrderLoading(false);
        setCardPlaceOrderLoading(false);

        setTimeout(() => {
            setIsCardPayment(false);
            setShowCheckoutSuccessBlink(false);
            setCheckoutCartData({ items: [], total: 0, currency: "NOK", currencySymbol: "kr" });
            setQuickBuyPopup(false);
            setShowPaymentPopup(false);
            setShowRightCheckoutPanel(false);
            setShowBOImagePageID(false);
            setShowRightUserLocationPanel(false);
            navigate("/explore");
            callback(newOrder);
            setOrderID(orderID);
            setShowThankyouPopup(true);
            logGA4Event("ThankYou");
        }, 2100);
    };

    const callback = data => {
        const { firstName, lastName, email, mobileNumber } = data;
        setUserData({
            firstName: firstName,
            lastName: lastName,
            phoneCountryPrefix: "+47",
            email: email,
            phone: mobileNumber
        });
    };

    const closeClicked = () => {
        setSelectedPaymentType(paymentMethods.CARD);
        setShowRightCheckoutPanel(false);
    };

    const resetValidation = () => {
        setStripeCardData({
            isCardNumber: false,
            isCardExpData: false,
            isCardCvv: false,
            isComplete: false
        });
    };

    //order creation function
    // TODO: payload is a bit new for saved card
    const createNewOrder = async (updateResponse, cardCredentials, cardDetail) => {
        setPlaceOrderLoadingAnimation(true);
        const _accountID = BOTagAccountID;
        let item;
        if (checkoutCartData) {
            const arr = [];
            checkoutCartData.map(checkOutData => {
                const data = checkOutData?.BOTagData;
                const algorithmData = checkOutData?.BOTagAlgorithmData;
                const coordinates = checkOutData?.UserGPSCoordinates;
                const address = `${checkOutData?.UserAddress?.street} ${checkOutData?.UserAddress?.streetNumber}, ${checkOutData?.UserAddress?.postCode} ${checkOutData?.UserAddress?.city}, ${checkOutData?.UserAddress?.country}`;
                const payload = {
                    GTINbarcode: data?.GTINbarcode, //done
                    storeID: algorithmData?.storeDetail?._id, //done
                    productname: data?.productName, //done
                    brandName: data?.labelBrandName, //done
                    itemPrice: algorithmData?.discountPrice ? algorithmData?.discountPrice : algorithmData?.price, //done
                    isDiscount: algorithmData?.discountPrice ? true : false, //done
                    originalItemPrice: algorithmData?.price, //done
                    deliveryCost: algorithmData?.deliveryCharges || 0,
                    deliveryOption: algorithmData?.type, //done
                    deliveryPreferences: data?.deliveryPreference, //done
                    quantity: data?.selectedQuantity,
                    BOimageID: selectedBOImageData?._id,
                    deliveryID: algorithmData?.cf?._id || undefined, //done
                    brandID: data?.labelBrandID, //done
                    userLocation: {
                        address: address, //done
                        country: checkOutData?.UserAddress?.country, //done
                        latitude: coordinates?.latitude, //done
                        longitude: coordinates?.longitude, //done
                        courierInstructions:
                            checkOutData?.BOTagData?.deliveryMethod === "courier"
                                ? courierInstructionsData[checkOutData?.itemID]
                                : "undefined" //TODO: not done
                    }
                };
                if (algorithmData?.type === "shipping") {
                    if (shippingAddressPopupData?.shippingAddressChangedInPopup) {
                        payload.userLocation = {
                            address: shippingAddressPopupData?.addressName, //done
                            country: shippingAddressPopupData?.country, //done
                            latitude: coordinates?.latitude, //done
                            longitude: coordinates?.longitude, //done
                            doorNumber: shippingAddressPopupData?.addressNumber, //done
                            postCode: shippingAddressPopupData?.postCode, //done
                            city: shippingAddressPopupData?.city, //done

                            recipientFirstName: shippingRecipient?.firstName, //done
                            recipientLastName: shippingRecipient?.lastName, //done
                            recipientCompanyName: shippingRecipient?.company, //done
                            floor: shippingAddressPopupData?.floor //done
                        };
                    } else {
                        payload.userLocation = {
                            address: address,
                            country: checkOutData?.UserAddress?.country,
                            latitude: coordinates?.latitude,
                            longitude: coordinates?.longitude,
                            // doorNumber: shippingUserAddress?.addressNumber, //TODO: not done
                            postCode: checkOutData?.UserAddress?.postCode,
                            city: checkOutData?.UserAddress?.city,
                            recipientFirstName: data?.recipientJson?.firstName || userData?.firstName,
                            recipientLastName: data?.recipientJson?.lastName || userData?.lastName,
                            recipientCompanyName: data?.company,
                            floor: checkOutData?.UserAddress?.floor
                        };
                    }
                }
                arr.push(payload);
            });
            item = arr;
        }
        const newOrder = {
            firstName: paymentPopupData?.firstName || userData?.firstName,
            lastName: paymentPopupData?.lastName || userData?.lastName,
            email: paymentPopupData?.email || userData?.email,
            cardName: checkoutPaymentData?.cardHolderName || "",
            cardNumber: checkoutPaymentData?.cardNumber || "",
            cardExpireDate: checkoutPaymentData?.cardExpDate || "",
            cardCVV: checkoutPaymentData?.cardCVV || "",
            mobileNumber: paymentPopupData?.phoneNumber || userData?.phone,
            items: item,
            accountID: _accountID || undefined,
            stripeUpdateResponse: updateResponse || {},
            cardCredentials: cardCredentials || undefined,
            // shippingUserAddress: shippingUserAddress || undefined, //TODO: not done
            cardDetail: cardDetail
        };
        const response = await axios.post(`${process.env.REACT_APP_API_URL}${CREATE_ORDER}`, newOrder);

        if (response?.status === 200) {
            setSuccessOrder(true);
            const orderID = response.data?.orderID;
            setThankYouAmount(Formatter.formatPrice(checkoutCartData?.total));
            setShowCheckoutSuccessBlink(true);
            resetStates({ newOrder, orderID });
        }
    };

    //stripe function
    const handleSubmit = async ({ savedPaymentMethodType = null }) => {
        if (savedPaymentMethodType === paymentMethods.CARD) {
            setPlaceOrderLoading(true);
            setIsCardPayment(false);
        } else if (savedPaymentMethodType === paymentMethods.GOOGLE_PAY || selectedPaymentType === paymentMethods.KLARNA_PAY) {
            setIsCardPayment(false);
            setPlaceOrderLoading(true);
        } else {
            setCardPlaceOrderLoading(true);
            setIsCardPayment(true);
        }

        logGA4Event("Payment_Loading");
        try {
            if (
                selectedPaymentType === paymentMethods.APPLE_PAY ||
                selectedPaymentType === paymentMethods.GOOGLE_PAY ||
                savedPaymentMethodType === paymentMethods.GOOGLE_PAY
            ) {
                const checkoutTotal = checkoutCartData?.total || 0;
                const amount = Number((checkoutTotal * 100).toFixed(0));
                await paymentRequest?.update?.({
                    country: "NO",
                    currency: "nok",
                    total: {
                        label: "Demo total",
                        amount
                    }
                });
                paymentRequest?.show?.();
                return;
            }
            const { data: res } = await createStripePayment({
                cartData: checkoutCartData,
                checkoutPaymentData,
                paymentPopupData,
                selectedPaymentType,
                userData
            });

            if (res?.success) {
                const cardElement = elements.getElement(CardElement);
                const data = await handlePaymentMethods({
                    type: selectedPaymentType,
                    cardElement,
                    paymentIntent: res.paymentIntent,
                    stripe,
                    savedPaymentMethodType,
                    checkoutPaymentData,
                    paymentPopupData: paymentPopupData?.email ? paymentPopupData : userData || {},
                    paymentRequest
                });

                await handleCreateOrderPostPayment({ cardElement, data, savedPaymentMethodType, res, selectedPaymentType });
            }
        } catch (err) {
            logGA4Event("PaymentFailed_PopUp");

            setPlaceOrderLoading(false);
            setShowPaymentPopup(false);
            resetValidation();
            setCardPlaceOrderLoading(false);
        }
    };
    /* #endregion */

    return (
        <StyledCheckoutPanel className={`multi-bag-desktop-panel ${placeOrderLoading ? "blur-bg" : ""}`}>
            <PanelHeader
                closeClicked={closeClicked}
                isMobile={isMobile}
                setSelectedOption={setSelectedOption}
                selectedOption={selectedOption}
                checkoutCartData={shopperBagItem}
            />
            {showPaymentPopup && (
                <PaymentPopup
                    handleSubmit={handleSubmit}
                    placeOrderLoadingAnimation={placeOrderLoadingAnimation}
                    successOrder={successOrder}
                />
            )}

            {shopperBagItem?.length <= 0 ? (
                <EmptyCheckoutLayout />
            ) : (
                <CheckoutItemsLayout
                    checkoutCartData={shopperBagItem}
                    singleItemId={singleItemId}
                    setSingleItemId={setSingleItemId}
                    isMobile={isMobile}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                />
            )}
            {shopperBagItem?.length > 0 && <ConfirmPurchaseLayout handleSubmit={handleSubmit} />}
        </StyledCheckoutPanel>
    );
}

/* #region SMALL COMPONENTS */
const PanelHeader = ({ closeClicked, isMobile, selectedOption, setSelectedOption, checkoutCartData }) => {
    const deliveryMethods = new Set(checkoutCartData?.map(item => item?.deliveryOption));
    const isSameLocation = checkoutCartData?.every(item => {
        const address = item?.userLocation;
        const firstAddress = checkoutCartData[0]?.userLocation;
        return (
            address?.street === firstAddress?.street &&
            address?.city === firstAddress?.city &&
            address?.country === firstAddress?.country &&
            address?.postCode === firstAddress?.postCode
        );
    });
    const [locationInfo, setLocationInfo] = useState(true);
    useEffect(() => {
        setLocationInfo(false);
        if (isSameLocation) {
            setLocationInfo(true);
        } else {
            setLocationInfo(false);
        }
    }, [isSameLocation]);
    const shouldShowHeader = deliveryMethods.size > 1;
    return (
        <div style={{ flexShrink: 0, marginRight: isMobile && "16px" }}>
            <div className="panel-headers">
                <div className="frame-313366">
                    <div className="quick-checkout">Quick checkout</div>
                </div>
                <div className="frame-313365">
                    <div className="btn-xs-secondary cursor-pointer" onClick={closeClicked}>
                        <div className="button">Close</div>
                    </div>
                </div>
            </div>
            <hr className="separator" />
            {!locationInfo && <InfoNote setLocationInfo={setLocationInfo} />}

            {shouldShowHeader && <CheckoutCardHeader selectedOption={selectedOption} setSelectedOption={setSelectedOption} />}
        </div>
    );
};

const EmptyCheckoutLayout = () => {
    return (
        <div className="empty-checkout">
            <div className="frame-313697">
                <div className="frame-313691">
                    <img className="vector" src={Vector} alt="" />
                    <div className="your-checkout-is-empty">Your checkout is empty...</div>
                </div>
            </div>
        </div>
    );
};

const CheckoutItemsLayout = ({ checkoutCartData, isMobile, selectedOption, setSelectedOption }) => {
    const filteredData = checkoutCartData?.filter(item => {
        return item?.deliveryOption?.toLowerCase() === selectedOption?.toLowerCase();
    });
    const selectedDate = selectedOption === "All" ? checkoutCartData : filteredData;

    function mergeDuplicateItems(items) {
        // Map to store unique items by a composite key
        const itemMap = {};
        // Iterate through the items
        items.forEach(item => {
            // Create a unique key based on critical fields
            const key = `${item.GTINbarcode}-${item.labelBrandID}-${item.productDetails.name}-${item.productDetails.size}-${item.productDetails.color}-${item.deliveryOption}-${item.deliveryPreferences}`;

            if (!itemMap[key]) {
                // Initialize the item with quantity 1
                itemMap[key] = { ...item, quantity: 1 };
            } else {
                // Increment quantity and merge courierDetails if present
                itemMap[key].quantity += 1;
                if (item.courierDetails) {
                    itemMap[key].courierDetails = { ...item.courierDetails };
                }
            }
        });

        // Convert the map values to an array
        return Object.values(itemMap);
    }
    const mergedItems = mergeDuplicateItems(selectedDate);
    useEffect(() => {
        if (filteredData?.length <= 0) {
            setSelectedOption("All");
        }
    }, [filteredData]);
    return (
        <div style={{ overflow: "auto", paddingRight: isMobile && "16px", height: "100%" }}>
            <CheckoutItemsStyles className="frame-29739" style={{ gridTemplateColumns: mergedItems?.length <= 1 ? "1fr" : "1fr 1fr" }}>
                {mergedItems?.map((item, index) => {
                    return (
                        <div className="w-100" key={index}>
                            {item?.deliveryOption?.toLowerCase() === "pickup" ||
                            item?.deliveryOption?.toLowerCase() === "courier" ||
                            item?.deliveryOption?.toLowerCase() === "shipping" ? (
                                <CheckoutItemCard item={item} cartCount={mergedItems.length} />
                            ) : (
                                <div>Delivery method not implemented: {item?.deliveryOption}</div>
                            )}
                        </div>
                    );
                })}
            </CheckoutItemsStyles>
        </div>
    );
};
/* #endregion */
